import { parentNavigate } from "./ParentNavigate";

function Breadcrumbs({ crumbs }) {
  return (
    <>
      {crumbs?.length > 0 && (
        <div className="flex flex-wrap table-text items-center w-full leading-3 text-[12px]">
          {crumbs?.map((crumb, index) => (
            <span key={index} className="inline-flex breadcrumb-item items-center">
              {index !== 0 && <p className="mx-1 leading-3 text-[12px]"> / </p>}
              {index !== crumbs.length - 1 ? (
                <button
                  type="button"
                  onClick={() => parentNavigate(crumb.path)}
                  className="hover:text-[var(--primary-text-color)] no-underline hover:no-underline focus:outline-none focus:ring-0 focus-visible:outline-none border-none bg-transparent p-0 cursor-pointer"
                >
                  {crumb.name}
                </button>
              ) : (
                crumb.name // Last crumb, no link
              )}
            </span>
          ))}
        </div>
      )}
    </>
  );
}

export default Breadcrumbs;
